import { version as uuidVersion, validate as validateUuid } from 'uuid';
import { stringContains } from './string';

export const formatTenantName = (tenantName: string) => {
    return tenantName.replace('@', '');
};

export const getTenantId = () => {
    const pathTenantId = window.location.pathname.split('/')[1];

    // Tenant IDs are V4 UUIDs
    if (!validateUuid(pathTenantId) || uuidVersion(pathTenantId) !== 4) {
        throw new Error('Invalid tenant ID');
    }

    return pathTenantId;
};

export const isSubtenant = (tenantName: string) => stringContains(tenantName, '+');
